import type { AuthRoleInfo } from '@/types';

/**
 * The role codes the role UI resolves: a system role's own code (`name`),
 * a custom role the system role the API matched it to (`uiRoleCode`).
 */
export function roleUiCodes(roles: readonly Pick<AuthRoleInfo, 'name' | 'uiRoleCode'>[]): string[] {
  return roles.map((role) => role.uiRoleCode ?? role.name);
}
